import { ref, computed, watch } from "vue";
import { useNuxtApp } from "#app";
import { isFunction, isString } from "@spoferan/spoferan-ts-core";
import { useFormSubmits } from "./useFormSubmits.mjs";
export const SubmittableComponentEmits = ["success", "error", "update:loading"];
export function useSubmittableComponent(props, emit, options) {
  const { $confirm } = useNuxtApp();
  const isLoading = ref(props.loading ?? false);
  watch(isLoading, (newValue) => {
    emit("update:loading", newValue);
  });
  watch(() => props.loading, (newValue) => {
    isLoading.value = newValue ?? false;
  });
  const actionUrl = computed(() => {
    return isString(props.action) ? props.action : null;
  });
  const {
    submitForm,
    handleSuccess,
    handleError
  } = useFormSubmits({
    langParams: props.langParams,
    silent: props.withoutFeedback,
    withError: props.withError,
    alert: props.alert,
    notification: props.notification,
    successHandler: (data, response) => {
      emit("success", data, response);
      options?.successHandler?.(data, response);
    },
    errorHandler: (status, error) => {
      emit("error", status, error);
      options?.errorHandler?.(status, error);
    }
  });
  function submit(data = null) {
    checkForSubmitPermission((hasPermission, confirmData = {}) => {
      if (hasPermission) {
        isLoading.value = true;
        data = data ?? props.data ?? {};
        const submitData = { ...data, ...confirmData };
        if (!props.action) {
          if (!props.persistSuccessLoading) {
            isLoading.value = false;
          }
          if (options?.successHandler) {
            options.successHandler(submitData, { data: submitData });
          }
        } else if (actionUrl.value) {
          submitForm(actionUrl.value, submitData, {
            method: props.method,
            guest: props.asGuest
          }).then(() => {
            if (!props.persistSuccessLoading) {
              isLoading.value = false;
            }
          }).catch(() => {
            isLoading.value = false;
          });
        } else if (isFunction(props.action) && props.action.length < 2) {
          props.action(submitData);
          if (!props.persistSuccessLoading) {
            isLoading.value = false;
          }
          if (options?.successHandler) {
            options.successHandler(submitData, { data: submitData });
          }
        } else {
          props.action(submitData, (success, response = { data }) => {
            if (!props.persistSuccessLoading) {
              isLoading.value = false;
            }
            if (success === true) {
              handleSuccess(response);
            } else if (success === false) {
              handleError(response);
            }
          });
        }
      } else {
        isLoading.value = false;
      }
    });
  }
  function checkForSubmitPermission(callback) {
    if (props.confirm) {
      $confirm({
        title: props.confirm.title,
        text: props.confirm.message,
        type: props.confirm.type ?? "warning",
        inputs: props.confirm.inputs,
        confirmText: props.confirm.accept,
        cancelText: props.confirm.cancel
      }).then(({ confirmed, data }) => {
        callback(confirmed, data);
      });
    } else {
      callback(true);
    }
  }
  return {
    isLoading,
    actionUrl,
    submit
  };
}
